import { render, staticRenderFns } from "./betch-copy.vue?vue&type=template&id=5a8773cf"
import script from "./betch-copy.vue?vue&type=script&lang=js"
export * from "./betch-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports